import React, {useEffect, useState} from "react";
import './DDFRedemption.css';
import Strings from "../../../config/Strings";
import {Form, Spinner} from "react-bootstrap";
import {TigerButton} from "../../../global/tiger-button/TigerButton";
import {GetFilteredResources, GetUnauthorizedResources} from "../../../api/SpineClient";
import GlobalConstants from "../../../config/GlobalConstants";
import {InfoModal} from "../../../global/ConfirmationModal";
import {useHistory, useLocation} from "react-router";
import ddf_graphic_1 from "../../../../assets/images/ddf-grafik_01.png";
import ddf_graphic_2 from "../../../../assets/images/ddf-grafik_02.png";
import ddf_graphic_3 from "../../../../assets/images/ddf-grafik_03.png";
import ddf_graphic_4 from "../../../../assets/images/ddf-grafik_04.png";
import tigertones_logo from "../../../../assets/images/ddf-tigertones-logo-k.png";
import tigertones_app_icon from "../../../../assets/images/ddf-tigertones-app-icon.png";
import tigerbox_touch_logo from "../../../../assets/images/tigerbox_touch_logo.png";
import ReactPlayer from "react-player";

export default function DDFRedemptionTicketValidation() {

    const queryParams = new URLSearchParams(window.location.search);

    const [form, setForm] = useState({code: queryParams.get("code"), pin: null});
    const [formError, setFormError] = useState({code: null, pin: null});
    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorText, setErrorText] = useState(null);
    const history = useHistory();
    const location = useLocation();

    document.title = Strings.DDF_REDEMPTION_BROWSER_TAB;

    useEffect(() => {
        if (queryParams.get("code") != null) {
            GetUnauthorizedResources('api/purchases/coupons/search/minimal-by-code', {code: queryParams.get("code")},
                'application/json', GlobalConstants.BILL_HOST)
                .then(r => {
                    if (!r.error && r.result != null && r.result.couponType === "DDF" && r.result.used) {
                        //DDF Coupon is already redeemed
                        GetUnauthorizedResources("api/purchases/coupons/deeplinks/ddf?redirect=false", {}, 'application/json', GlobalConstants.BILL_HOST)
                            .then(redirect => {
                                if (!redirect.error && redirect.result != null && redirect.result.targetUrl) {
                                    window.scrollTo(0, 0);
                                    window.location.href = redirect.result.targetUrl;
                                }
                            });
                    }
                });
        }

        if (location !== undefined && location.hash !== "") {
            const element = document.getElementById(location.hash);
            if (element) {
                element.scrollIntoView({behavior: "smooth", block: "start"});
            }
        }
    });

    if (location !== undefined && location.hash !== "") {
        const element = document.getElementById(location.hash);
        if (element) {
            element.scrollIntoView({behavior: "smooth", block: "start"});
        }
    }

    //Submitting
    const validateTicket = async e => {
        setLoading(true);
        e.preventDefault();

        //First check if it's a ddf
        let minimalCoupon = await GetUnauthorizedResources('api/purchases/coupons/search/minimal-by-code', {code: form.code},
            'application/json', GlobalConstants.BILL_HOST);
        if (minimalCoupon.error) {
            if (minimalCoupon.result === 404) {
                setFormError({
                    ...formError,
                    code:  Strings.DDF_REDEMPTION_CODE_ERROR_1
                });
            } else {
                setErrorText(Strings.DDF_REDEMPTION_UNKNOWN_ERROR);
                setShowError(true);
            }
            setLoading(false);
            return;
        } else {
            if (minimalCoupon.result.couponType !== "DDF") {
                setFormError({
                    ...formError,
                    code:  Strings.DDF_REDEMPTION_CODE_ERROR_1
                });
                setLoading(false)
                return;
            }
        }

        let validation = await GetFilteredResources('api/purchases/coupons/validate', form,
            'application/json', GlobalConstants.BILL_HOST);

        setLoading(false);

        if (validation.error) {
            setErrorText(Strings.DDF_REDEMPTION_UNKNOWN_ERROR)
            setShowError(true);
        } else {
            await handleValidationResult(validation.result);
        }
    }

    const downloadQuickguide = () => {
        // using Java Script method to get PDF file
        fetch('TM_DDF_Quickguide.pdf').then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'TM_DDF_Quickguide.pdf';
                alink.click();
            })
        })
    }

    const handleValidationResult = async (result) => {
        let valid = result.valid;
        const code = result.code;
        let alreadyUsed = false;

        //Validate the response from the purchase service
        switch (code) {
            case 1:
                //Coupon does not exist
                setFormError({
                    ...formError,
                    code:  Strings.DDF_REDEMPTION_CODE_ERROR_1
                });
                break;
            case 2:
                //Coupon temporary disabled for X Minutes
                setFormError({
                    ...formError,
                    code: Strings.DDF_REDEMPTION_CODE_ERROR_2.replace("{0}", result.value)
                });
                break;
            case 3:
                //Wrong PIN provided for last time -> Coupon is now disabled
                setFormError({
                    ...formError,
                    code: Strings.DDF_REDEMPTION_CODE_ERROR_3
                });
                break;
            case 4:
                //Wrong PIN provided -> X retries left
                setFormError({
                    ...formError,
                    pin: Strings.DDF_REDEMPTION_PIN_ERROR_1.replace("{0}", result.value)
                });
                break;
            case 5:
                //Coupon has been already used
                alreadyUsed = true;
                break;
            default:
                //Coupopn has not been used yet
                valid = true;
                break;
        }

        //In case of an already used ticket, redirect to ddf playlist (depending on client)
        if (alreadyUsed) {
            let redirect = await GetUnauthorizedResources("api/purchases/coupons/deeplinks/ddf?redirect=false", {});
            if (!redirect.error && redirect.result != null && redirect.result.targetUrl) {
                window.scrollTo(0, 0);
                window.location.href = redirect.result.targetUrl;
            }
        } else if (valid) {
            //It's not used -> It can be redeemed (proceed to next step)
            sessionStorage.setItem('ls.ddf', JSON.stringify(form));
            history.push("/" + GlobalConstants.APP_PATH + "ddflive/authenticate#ddf-authentication-register")
        }
    }

    const updateForm = (field, value) => {
        setForm({
            ...form,
            [field]: value.toUpperCase()
        });
        setFormError({
            ...formError,
            [field]: null
        });
    }

    //Rendering
    return (
        <div className="ddf-container">
            <div className="ddf-taipan" id="#ddf-validation"/>
            <div className="ddf-page-headline" dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_HEADLINE}} />

            <div className="ddf-section-white">
                <div className="ddf-section-text-content">
                    <Form className="text-left" onSubmit={(e) => validateTicket(e)}>
                        {/* CODE */}
                        <Form.Group className="mb-3" controlId="ticketRedemptionTicketNo">
                            <Form.Label className="ddf-form-label">{Strings.DDF_REDEMPTION_LABEL_CODE}</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                isInvalid={ formError.code != null}
                                value={form.code}
                                onChange={e => updateForm('code', e.target.value)}
                                plaintext={"Code"}
                                placeholder={Strings.DDF_REDEMPTION_CODE_PLACEHOLDER}
                            />

                            <Form.Control.Feedback type="invalid">
                                {formError.code}
                            </Form.Control.Feedback>
                        </Form.Group>

                        {/* PIN */}
                        <Form.Group className="mb-3" controlId="ticketRedemptionTicketPin">
                            <Form.Label className="ddf-form-label">{Strings.DDF_REDEMPTION_LABEL_PIN}</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                isInvalid={ formError.pin != null}
                                value={form.pin}
                                onChange={e => updateForm('pin', e.target.value)}
                                plaintext={"PIN"}
                                placeholder={Strings.DDF_REDEMPTION_PIN_PLACEHOLDER}
                            />

                            <Form.Control.Feedback type="invalid">
                                {formError.pin}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <br />

                        <TigerButton className="w-100" variant="red" disabled={loading}>
                            {loading ?
                                <Spinner animation="border" />
                                :
                                Strings.TICKET_REDEMPTION_SUBMIT_CREDENTIALS}
                        </TigerButton>

                    </Form>
                    <br />
                    <div dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_INFO}} />
                </div>
            </div>
            <div className="ddf-section-black">
                <div className="ddf-section-image-content-shifted" id="#vip">
                    <img src={ddf_graphic_1} alt={"Die Drei ??? VIP-Pass"} />
                </div>
            </div>
            <div className="ddf-section-white">
                <div className="ddf-section-text-content">
                    <div className="ddf-section-headline" dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_HEADLINE_2}} />
                    <br />
                    <div dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_INFO_2}} />
                </div>
            </div>
            <div className="ddf-section-black">
                <div className="ddf-section-text-content">
                    <div className="ddf-section-headline" dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_HEADLINE_3}} />
                    <div className="ddf-section-image-content">
                        <ReactPlayer
                            url= {"https://youtu.be/xfUwebg_mRQ"}
                            width='100%'
                            controls = {true}
                        />
                    </div>
                    <div className="ddf-section-image-content">
                        <img src={ddf_graphic_2} alt={"Die Drei ??? VIP-Pass"} />
                    </div>
                    <br />
                    <div dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_INFO_3}} onClick={() => downloadQuickguide()}/>
                    <br />
                    <br />
                    <div className="ddf-section-headline" dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_HEADLINE_4}} />
                </div>
            </div>
            <div className="ddf-section-black">
                <div className="ddf-section-image-content-shifted">
                    <img src={ddf_graphic_3} alt={"Die Drei ??? VIP-Pass"} />
                </div>
            </div>
            <div className="ddf-section-black">
                <div className="ddf-section-text-content" dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_INFO_4}} />
                <br />
                <div className="ddf-section-image-content">
                    <img src={tigerbox_touch_logo} alt={"tigerbox TOUCH logo"} />
                </div>
            </div>
            <div className="ddf-section-white">
                <div className="ddf-section-text-content">
                    <div className="ddf-section-headline" dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_HEADLINE_5}} />
                    <br />
                    <img src={tigertones_app_icon} className="ddf-icon" alt={"tigertones icon"} />
                    <br />
                    <br />
                    <div dangerouslySetInnerHTML={{__html: Strings.DDF_REDEMPTION_INFO_5}} />
                </div>
                <div className="ddf-section-image-content">
                    <img src={ddf_graphic_4} alt={"Die drei ??? VIP-Pass"}/>
                    <br />
                    <img src={tigertones_logo} className="ddf-icon" alt={"tigertones logo"} />
                </div>
            </div>

            <InfoModal
                title={Strings.REGISTER_UNKNOWN_ERROR_TITLE}
                text={errorText}
                show={showError}
                onHide={() => setShowError(false)} />
        </div>
    )

}